import { computed, Signal, signal, WritableSignal } from '@angular/core';
import { SecurityMetadata } from '../../abstractions/security-metadata';

export class TaxResultItemField {
  isInvalid: Signal<boolean> = computed(
    () =>
      !!(
        (this.value() === undefined ||
          this.value().toString().trim() === '' ||
          this.hasDuplicatedValue()) &&
        !this.ignoreValidation
      )
  );
  hasChanges: Signal<boolean> = computed(
    () =>
      !!(
        this.value() !== undefined && this.value()?.trim() !== this.initialValue
      )
  );
  value: WritableSignal<string> = signal('');
  metadata!: SecurityMetadata;
  uuid!: string;
  initialValue!: string;
  previousValue: string = '';
  ignoreValidation = false;
  hasDuplicatedValue = signal(false);
}
